import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Create, Palette, Delete} from '@mui/icons-material'
import Dialog from 'components/Dialog'
import PlanningConfig from 'components/PlanningConfig'
import PlanningColors from 'components/PlanningColors'
import Confirmation from 'components/Confirmation'
import SchedulerConfig from 'components/SchedulerConfig'

const Actions = styled.div`
    background-color: rgba(0, 0, 0, .4);
    top: 117px;
    position: absolute;
    width: 100%;
`

const IconButton = styled.button`
    background-color: transparent;
    color: rgba(255, 255, 255, .7);
    font-size: 10px;
    width: 100%;
    height: 60px;
    padding: 10px 5px;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;

    :hover {
        background-color: rgba(0, 0, 0, .4);
        color: #ffc300;
    }
`

const PlanningMenu = ({data, colors, permissions, setFilter, setColors, deletePlanning, scheduler, intl}) => {
    const [open, setOpen] = React.useState(null)

    const handleOpen = (type) => {
        setOpen(type)
    }

    const handleClose = () => {
        setOpen(null)
    }

	const handleConfirm = () => {
		deletePlanning(data.id)
		handleClose()
	}

    return (
        <React.Fragment>
            {permissions.Designer &&
                <Actions>
                    <React.Fragment>
                        <IconButton onClick={() => handleOpen('config')}>
                            <Create />
                            {intl.formatMessage({id: "planning.edit"})}
                        </IconButton>
                        {!!colors.length &&
                            <IconButton onClick={() => handleOpen('colors')}>
                                <Palette />
                                {intl.formatMessage({id: "planning.colors"})}
                            </IconButton>
                        }
						<IconButton onClick={() => handleOpen('delete')}>
                            <Delete />
                            {intl.formatMessage({id: "planning.delete"})}
                        </IconButton>
                    </React.Fragment>
                </Actions>
            }
            <Dialog
                fullWidth={true}
                open={!!open}
                onClose={handleClose}
            >
				{open === 'config' &&
                    <React.Fragment>
                        {scheduler ?
                            <SchedulerConfig
                                data={data}
                                handleClose={handleClose}
                                setFilter={setFilter}
                            />
                            :
                            <PlanningConfig
                                data={data}
                                handleClose={handleClose}
                                setFilter={setFilter}
                            />
                        }
                    </React.Fragment>
				}
				{open === 'colors' &&
					<PlanningColors
						planning={data.id}
						colors={colors}
						data={data.colors && data.colors.filter(item =>
							colors.find(color => color.fieldId === item.fieldId))}
						handleClose={handleClose}
						setColors={setColors}
					/>
				}
				{open === 'delete' &&
					<Confirmation
						handleConfirm={handleConfirm}
						handleClose={handleClose}
						text={intl.formatMessage({id: "planning.confirm_delete"}, {name: data.name})}
					/>
				}
            </Dialog>
        </React.Fragment>
    )
}

export default injectIntl(PlanningMenu)
